import React from 'react';

const PlayMarketButton = () => {
    return (
        <div className={'store_button_wrapper'}>
            <button
                className={'store_button'}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
                    <path
                        d="M11.8069 10.398L2.08993 0.670044H2.18393C3.14881 0.740309 4.07903 1.05934 4.88393 1.59604L15.0779 7.11004L11.8069 10.398ZM10.8619 11.341L0.879931 21.3C0.568917 20.6938 0.426617 20.0151 0.467931 19.335V3.33504C0.427541 2.65468 0.570881 1.97597 0.882931 1.37004L10.8619 11.341ZM11.8069 12.269L15.0779 15.556L4.88693 21.07C4.082 21.6069 3.15184 21.9262 2.18693 21.997H2.08893L11.8059 12.27L11.8069 12.269ZM16.3069 7.76904L12.7529 11.34L16.3069 14.893L18.4619 13.721C19.2559 13.286 20.4619 12.493 20.4619 11.341C20.4619 10.169 19.2519 9.37604 18.4619 8.94104L16.3029 7.77004L16.3069 7.76904Z"
                        fill="#191919"/>
                </svg>
                <div className={'store_button_titles'}>
                    <span className={'store_button_titles_action'}>GET IT ON</span>
                    <span className={'store_button_titles_store'}>Google Play</span>
                </div>
            </button>
            <span className={'coming_soon'}>Coming Soon</span>
        </div>
    );
};

export default PlayMarketButton;